module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Place-To-Call-Home-A-S6.5dd23ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Place-To-Call-Home-A-S6.jpg
// module id = 2f5j
// module chunks = 0